export default "__VITE_ASSET__BvT5psmt__"